import { useNavigate } from "react-router-dom";
import SuccessImage from "../assets/Images/BrandSignupSuccess.svg";
import Button from "../components/atoms/buttons/Button";

function ComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="mt-20 grid grid-cols-10 gap-y-3">
      <div className="col-span-10 flex justify-center">
        <img src={SuccessImage} alt="success" />
      </div>
      <div className="col-span-10 flex justify-center font-sora text-xl font-bold md:text-3xl lg:text-6xl">
        Coming Soon
      </div>
      <div className="col-span-10 col-start-3 col-end-9 -mt-4 text-center  font-sora text-sm  md:text-base lg:text-lg">
        We&apos;re currently working hard on this page.
      </div>

      <div className="col-span-10  mt-5 flex  justify-center gap-x-5 font-sora">
        <Button
          additionalClasses="xl:text-xs
          2xl:text-sm xl:px-8 xl:py-3 2xl:px-10 2xl:py-4"
          text="HOME"
          onClick={() => navigate("/")}
        />
      </div>
    </div>
  );
}
export default ComingSoon;
